// import React, { useState } from "react";
// import ChatModal from "./ChatModal";
// import ChatBot from "./ChatBot";
import "./Footer.css";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaWhatsapp,
} from "react-icons/fa";
import { FiFacebook, FiInstagram } from "react-icons/fi";
import { Link } from "react-router-dom";

function XLogo(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="currentColor"
      viewBox="0 0 16 16"
      {...props}
    >
      <path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z" />
    </svg>
  );
}
export default function Footer() {
  // const [showChat, setShowChat] = useState(false);

  return (
    <>
      <footer className="bg-black text-white pt-5 pb-3 position-relative">
        <div className="container">
          <div className="row text-start">
            {/* Logo + Description */}
            <div className="col-md-3 mb-4">
              <img
                src={`${process.env.PUBLIC_URL}/logo_urbanneed.png`}
                alt="UrbanNeed Logo"
                className="mb-2"
                style={{
                  height: "40px",
                  marginRight: "15px",
                  borderRadius: "5px",
                }}
              />
              <p className="small">
                Your trusted platform for professional home services. Connect
                with verified service providers in your area.
              </p>
              <div className="d-flex gap-3 fs-5 mt-3">
                <a
                  href="https://www.facebook.com/people/Urban-Need/61577925795625/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white"
                >
                  <FiFacebook className="text-blue" size={26} />
                </a>
                <a
                  href="https://twitter.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white"
                >
                  <XLogo className="text-info" size={26} />
                </a>
                <a
                  href="https://www.instagram.com/urbanneed.co.uk/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white"
                >
                  <FiInstagram className="text-danger" size={26} />
                </a>
                <a
                  href="https://wa.me/918709742352"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white"
                >
                  <FaWhatsapp className="text-success" size={26} />
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div className="col-md-3 mb-2">
              <h6 className="fw-bold mb-3">Quick Links</h6>
              <ul className="list-unstyled small">
                <li>
                  <Link
                    to="/services"
                    className="text-white text-decoration-none"
                  >
                    All Services
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-white text-decoration-none">
                    About Us
                  </Link>
                </li>
                <li>
                  <Link
                    to="/contact"
                    className="text-white text-decoration-none"
                  >
                    Contact
                  </Link>
                </li>
                <li>
                  <Link to="/join" className="text-white text-decoration-none">
                    Join as a Provider
                  </Link>
                </li>
              </ul>
            </div>

            {/* Popular Services */}
            <div className="col-md-3 mb-2">
              <h6 className="fw-bold mb-3">Popular Services</h6>
              <ul className="list-unstyled small">
                <li>
                  <Link
                    to="/services"
                    className="text-white me-3 text-decoration-none"
                  >
                    Plumbing
                  </Link>
                </li>
                <li>
                  <Link
                    to="/services"
                    className="text-white me-3 text-decoration-none"
                  >
                    Electrical
                  </Link>
                </li>
                <li>
                  <Link
                    to="/services"
                    className="text-white me-3 text-decoration-none"
                  >
                    Cleaning
                  </Link>
                </li>
                <li>
                  <Link
                    to="/services"
                    className="text-white me-3 text-decoration-none"
                  >
                    Beauty Services
                  </Link>
                </li>
                <li>
                  <Link
                    to="/services"
                    className="text-white me-3 text-decoration-none"
                  >
                    AC Repair
                  </Link>
                </li>
              </ul>
            </div>

            {/* Contact Info */}
            <div className="col-md-3 mb-2">
              <h6 className="fw-bold mb-3">Contact Info</h6>
              <ul className="list-unstyled small">
                <li className="d-flex align-items-start mb-2">
                  <FaPhoneAlt className="me-2 text-golden mt-1" />
                  <a
                    href="tel:+918709742352"
                    className="text-white text-decoration-none"
                  >
                    +91 8709742352
                  </a>
                </li>
                <li className="d-flex align-items-start mb-2">
                  <FaEnvelope className="me-2 text-golden mt-1" />
                  <a
                    href="mailto:urbanneed@zohomail.in"
                    className="text-white text-decoration-none"
                  >
                    urbanneed@zohomail.in
                  </a>
                </li>
                <li className="d-flex align-items-start">
                  <FaMapMarkerAlt className="me-2 text-golden mt-1" />
                  {/* <span>213 Beechwood Road, LU4 9RZ</span> */}
                  <span>
                    We provide services in: Delhi, Gurgaon, Noida, and Bengaluru
                  </span>
                </li>
              </ul>
            </div>
          </div>

          {/* Divider */}
          <hr className="border-secondary my-4" />

          {/* Bottom Text */}
          <div className="text-center small text-golden mb-2">
            URBAN NEED SERVICES PRIVATE LIMITED — CIN:{" "}
            <strong>U96090JH2025PTC026046</strong>
          </div>

          <div className="d-md-flex justify-content-between text-secondary small text-center text-md-start">
            <div>
              &copy; Copyright {new Date().getFullYear()} Urban Need Services
              Private Limited. All rights reserved.
            </div>
            <div className="text-white">
              <Link
                to="/refund-cancellation-policy"
                className="text-white text-decoration-none me-2"
              >
                Refund & Cancellation
              </Link>
              <span className="mx-2">|</span>
              <Link
                to="/privacy-policy"
                className="text-white text-decoration-none me-2"
              >
                Privacy Policy
              </Link>
              <span className="mx-2">|</span>
              <Link
                to="/terms-conditions"
                className="text-white text-decoration-none"
              >
                Terms & Conditions
              </Link>
            </div>
          </div>
        </div>

        {/* Floating WhatsApp Button */}
        <a
          href="https://wa.me/447414093652"
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-success rounded-circle position-fixed d-flex align-items-center justify-content-center whatsapp-btn"
          style={{
            bottom: "25px",
            right: "25px",
            width: "45px",
            height: "45px",
            zIndex: 9999,
          }}
        >
          <FaWhatsapp size={28} />
        </a>
      </footer>

      {/* Uncomment if you also want chatbot */}
      {/* <ChatModal show={showChat} onHide={() => setShowChat(false)} />
      <ChatBot /> */}
    </>
  );
}
